import React from "react";

const AlertContext = React.createContext({
  message: "",
  type: "",
});

export default AlertContext;
